import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11bf633f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml50 p20 mr20"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "bold mb20"
}, "发布货源", -1));
const _hoisted_3 = {
  class: "flex_FSBS"
};
const _hoisted_4 = {
  style: {
    "width": "90%"
  }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "flex_size_1"
};
const _hoisted_7 = {
  class: "bold"
};
const _hoisted_8 = {
  style: {
    "width": "90%"
  }
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "flex_size_1"
};
const _hoisted_11 = {
  class: "bold"
};
const _hoisted_12 = {
  class: "flex_FAC mt20"
};
const _hoisted_13 = {
  class: "flex_FAC"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "pr5"
}, "约", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "pl20"
}, "吨", -1));
const _hoisted_16 = {
  class: "flex_FAC"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "pr5"
}, "约", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "pl20"
}, "方", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_AMap = _resolveComponent("AMap");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_result = _resolveComponent("el-result");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
    ref: "formRef",
    model: $setup.formData,
    rules: $setup.rules,
    "status-icon": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
      class: "flex_size_1",
      label: "装货地址",
      required: "",
      prop: "loading"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.loading, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "address_box flex",
          key: index,
          onClick: _withModifiers(() => $setup.openMap(1, index), ["stop"])
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, [_createVNode(_component_el_text, {
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.province ? item.province + item.city + item.district : "选择装货地址"), 1)]),
          _: 2
        }, 1024)]), item.address ? (_openBlock(), _createBlock(_component_el_text, {
          key: 0
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.address), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])], 8, _hoisted_5);
      }), 128))])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "flex_size_1",
      label: "卸货地址",
      required: "",
      prop: "unloading"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.unloading, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "address_box flex",
          key: index,
          onClick: _withModifiers(() => $setup.openMap(2, index), ["stop"])
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, [_createVNode(_component_el_text, {
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.province ? item.province + item.city + item.district : "选择卸货地址"), 1)]),
          _: 2
        }, 1024)]), item.address ? (_openBlock(), _createBlock(_component_el_text, {
          key: 0
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.address), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])], 8, _hoisted_9);
      }), 128))])]),
      _: 1
    })]), $setup.formData.hasInvoice ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: "受票方",
      prop: "invoiceId"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "56.5%"
        },
        modelValue: $setup.formData.invoiceId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.formData.invoiceId = $event),
        placeholder: "请选择受票方",
        onChange: _cache[1] || (_cache[1] = value => $setup.setFormData('invoiceId', value))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.invoiceTitleList, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.invoiceId,
            label: `企业名称：${item.name} ; 企业税号：${item.taxNo} `,
            value: item.invoiceId,
            disabled: !item.isOpen
          }, {
            default: _withCtx(() => [_createTextVNode("企业名称：" + _toDisplayString(item.name) + " ; 企业税号：" + _toDisplayString(item.taxNo), 1)]),
            _: 2
          }, 1032, ["label", "value", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_form_item, {
      label: "货物名称",
      prop: "goodsName"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $setup.formData.goodsName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.formData.goodsName = $event),
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        placeholder: "请输入货物名称",
        "remote-show-suffix": "",
        onChange: _cache[3] || (_cache[3] = value => $setup.setFormData('goodsName', value))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.goods, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.goodsName,
            label: item.goodsName,
            value: item.goodsName
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "pl30",
      label: "包装方式",
      prop: "packageName"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $setup.formData.packageName,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.formData.packageName = $event),
        placeholder: "请选择包装方式",
        onChange: _cache[5] || (_cache[5] = value => $setup.setFormData('packageName', value))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.packageList, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.packageTypeName,
            label: item.packageTypeName,
            value: item.packageTypeName
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]), _createVNode(_component_el_form_item, {
      label: "货物图片",
      class: "pt20"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.goodsPicUrlList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "mr10",
          key: index
        }, [_createVNode(_component_el_image, {
          style: {
            "width": "6vw",
            "height": "6vw",
            "border-radius": "5px",
            "display": "block"
          },
          src: item,
          "zoom-rate": 1.2,
          "max-scale": 7,
          "min-scale": 0.2,
          "preview-src-list": $setup.formData.goodsPicUrlList,
          "show-progress": "",
          "initial-index": index,
          fit: "cover"
        }, null, 8, ["src", "preview-src-list", "initial-index"]), _createVNode(_component_el_button, {
          type: "danger",
          style: {
            "width": "100%"
          },
          class: "mt10",
          onClick: () => $setup.removePic(index)
        }, {
          default: _withCtx(() => [_createTextVNode("移除")]),
          _: 2
        }, 1032, ["onClick"])]);
      }), 128)), _createVNode(_component_el_upload, {
        "auto-upload": false,
        action: "#",
        "show-file-list": false,
        "list-type": "picture-card",
        accept: ".jpg,.png,jpeg",
        "on-change": data => $setup.uploadPic(data)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Plus)]),
          _: 1
        })]),
        _: 1
      }, 8, ["on-change"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form_item, {
      class: "pt20",
      label: "预估货物数量",
      prop: "tonnage"
    }, {
      default: _withCtx(() => [_hoisted_14, _createVNode(_component_el_input_number, {
        modelValue: $setup.formData.tonnage,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.formData.tonnage = $event),
        "controls-position": "right",
        precision: 2,
        min: 0,
        step: 1,
        placeholder: "最大重量",
        onChange: _cache[7] || (_cache[7] = value => $setup.setFormData('tonnage', value))
      }, null, 8, ["modelValue"]), _hoisted_15]),
      _: 1
    })]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_form_item, {
      class: "pl95 pt20",
      prop: "square"
    }, {
      default: _withCtx(() => [_hoisted_17, _createVNode(_component_el_input_number, {
        modelValue: $setup.formData.square,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.formData.square = $event),
        "controls-position": "right",
        precision: 2,
        min: 0,
        step: 1,
        placeholder: "最大体积",
        onChange: _cache[9] || (_cache[9] = value => $setup.setFormData('square', value))
      }, null, 8, ["modelValue"]), _hoisted_18]),
      _: 1
    })]), _createVNode(_component_el_form_item, {
      class: "pt20",
      label: "需要车辆",
      prop: "carNum",
      required: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $setup.formData.carNum,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $setup.formData.carNum = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($setup.carNumMap), ([index, label]) => {
          return _openBlock(), _createBlock(_component_el_radio, {
            key: index,
            label: index,
            value: label,
            disabled: index == 0 && ($setup.formData.square > 60 || $setup.formData.tonnage > 80),
            border: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(label), 1)]),
            _: 2
          }, 1032, ["label", "value", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "温度需求",
      prop: "temperatureName",
      required: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $setup.formData.temperatureName,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $setup.formData.temperatureName = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.temperatureList, item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            key: item.temperatureName,
            label: item.temperatureName,
            border: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.temperatureName), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "pt20",
      label: "车长（最多选3项）",
      prop: "carLengthList"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $setup.formData.carLengthList,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $setup.formData.carLengthList = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.carLen, ({
          carLengthId,
          carLengthName
        }) => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            class: "mb10",
            key: carLengthName,
            label: {
              carLengthId,
              carLengthName
            },
            border: "",
            onChange: () => $setup.setSpecialFormData('carLengthList', carLengthName, 'carLengthName')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(carLengthName), 1)]),
            _: 2
          }, 1032, ["label", "onChange"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "pt20",
      label: "车型（最多选3项）",
      prop: "carModelList"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $setup.formData.carModelList,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.formData.carModelList = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.carType, ({
          vehicleTypeId,
          vehicleTypeName
        }) => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            key: vehicleTypeId,
            class: "mb10",
            label: {
              vehicleTypeId,
              vehicleTypeName
            },
            border: "",
            onChange: () => $setup.setSpecialFormData('carModelList', vehicleTypeName, 'vehicleTypeName')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(vehicleTypeName), 1)]),
            _: 2
          }, 1032, ["label", "onChange"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "pt20",
      label: "排放标准（最多选3项）",
      prop: "carDisplacementList"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $setup.formData.carDisplacementList,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.formData.carDisplacementList = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.carDischarge, ({
          carDisplacementId,
          carDisplacementName
        }) => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            class: "mb10",
            key: carDisplacementId,
            label: {
              carDisplacementId,
              carDisplacementName
            },
            border: "",
            onChange: () => $setup.setSpecialFormData('carDisplacementList', carDisplacementName, 'carDisplacementName')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(carDisplacementName), 1)]),
            _: 2
          }, 1032, ["label", "onChange"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "pt20",
      label: "装货时间",
      style: {
        "width": "30vw"
      },
      prop: "beginTime"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_config_provider, {
        locale: $setup.zhCn
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          clearable: false,
          modelValue: $setup.data.times,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.data.times = $event),
          type: "daterange",
          "range-separator": "至",
          "start-placeholder": "开始区间",
          "end-placeholder": "结束区间",
          format: "YYYY-MM-DD",
          onChange: $setup.setTimes
        }, null, 8, ["modelValue", "onChange"])]),
        _: 1
      }, 8, ["locale"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "mt20 flex",
      label: "货运费用",
      prop: "amount"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        style: {
          "width": "30vw"
        },
        modelValue: $setup.formData.amount,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $setup.formData.amount = $event),
        placeholder: "请输入货运费用"
      }, {
        append: _withCtx(() => [_createVNode(_component_el_select, {
          style: {
            "width": "10vw"
          },
          modelValue: $setup.formData.unitType,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $setup.formData.unitType = $event),
          placeholder: "请选择单位",
          onChange: _cache[17] || (_cache[17] = value => $setup.setFormData('unitType', value)),
          onVisibleChange: $setup.visibleChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.freightUnitTypeList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.type,
              label: '元/' + item.text,
              value: item.type,
              disabled: item.disabled
            }, {
              default: _withCtx(() => [_createTextVNode("元/" + _toDisplayString(item.text), 1)]),
              _: 2
            }, 1032, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onVisibleChange"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "备注",
      class: "pt20"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.formData.remark,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $setup.formData.remark = $event),
        type: "textarea",
        placeholder: "选填，请输入备注",
        maxlength: "200",
        "show-word-limit": "",
        rows: "6"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "pt40"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        style: {
          "width": "20vw",
          "margin": "auto"
        },
        type: "primary",
        onClick: _cache[20] || (_cache[20] = $event => $setup.submitForm($setup.formRef)),
        size: "large"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(!_ctx.$route.query.demandId ? "确认发货" : "保存"), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])]), _createVNode(_component_el_dialog, {
    title: "地图选点",
    center: "",
    fullscreen: "",
    modelValue: $setup.data.dialogVisible,
    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $setup.data.dialogVisible = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_AMap, {
      onSendCurrentAddress: $setup.getCurrentAddress,
      addressType: $setup.data.addressType,
      sort: $setup.data.sort
    }, null, 8, ["onSendCurrentAddress", "addressType", "sort"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    center: "",
    modelValue: $setup.data.resultVisible,
    "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $setup.data.resultVisible = $event),
    "show-close": false,
    "close-on-press-escape": false,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [_createVNode(_component_el_result, {
      icon: "success",
      title: !_ctx.$route.query.demandId || _ctx.$route.query.again ? '发货成功！' : '编辑成功！'
    }, {
      extra: _withCtx(() => [!_ctx.$route.query.demandId ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        size: "large",
        type: "primary",
        onClick: _cache[22] || (_cache[22] = () => $setup.data.resultVisible = false)
      }, {
        default: _withCtx(() => [_createTextVNode("继续发货")]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        size: "large",
        onClick: $setup.toPage
      }, {
        default: _withCtx(() => [_createTextVNode("前往发货管理")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}